// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Import the Supabase client directly from our centralized implementation
import { supabase as centralSupabaseClient } from '@/lib/supabase';

// Re-export the centralized client
export const supabase = centralSupabaseClient;

// Note: We keep this file to maintain backward compatibility with existing imports
// but delegate to the centralized implementation to prevent multiple instances
